import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useBloomreachAppointmentContent } from '@grandvisionhq/bloomreach';
import { isSafePath } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { getDirectionsUrl } from '@grandvisionhq/utils';
import { rescheduleAppointmentConfirmationScreenEvent } from '../../../../data-layer/actions.js';
import { useAddToCalendarDlEventDispatcher } from '../../../../data-layer/hooks/use-add-to-calendar-dl-event-dispatcher.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../../queries/get-availability-stores-nearby.js';
import '@grandvisionhq/stores-v2';
import '../../../../queries/book-appointment.js';
import '../../../../queries/book-appointment-by-id.js';
import '../../../../queries/get-user.js';
import '../../../../queries/get-calendar-availability-by-id.js';
import '../../../../queries/get-store-offer-by-code.js';
import '../../../../queries/get-store-offer-by-id.js';
import '../../../../queries/get-store-opening-times.js';
import '../../../../queries/get-store-opening-times-by-id.js';
import '../../../../queries/get-time-slots-by-id.js';
import 'date-fns';
import useStoreOfferById from '../../../../hooks/api/use-store-offer-by-id.js';
import '../../../../types/Forms.js';
import { AppointmentCommunicationChannel } from '../../../../types/shared.js';
import { fromArrayToString } from '../../../../utils/from-array-to-string.js';
import useVirtualAppointment from '../../../BookAppointment/hooks/use-virtual-appointment.js';
import { useRescheduleAppointmentContext } from '../../context/context.js';
import { useRoutingContext } from '../../context/RoutingContext/context.js';
import RescheduleAppointmentConfirmation from './RescheduleAppointmentConfirmation.js';

const emptyArray = [];
const RescheduleAppointmentConfirmationContainer = ()=>{
    var ref5;
    const { getLabel , getFormattedLabel  } = useIntl();
    const { appointment , store , selectedTimeSlot , config: { googleMapsApiKey , opco , storesUrl , appointmentTypes , offerFallbackImageUrl  } ,  } = useRescheduleAppointmentContext();
    const [getStoreOffer, storeOffer] = useStoreOfferById({
        globalStoreId: '0'
    });
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [, { queryParams: { returnPath , returnLabel  } ,  }, ] = useRoutingContext();
    const { appointmentDisplayType  } = useBloomreachAppointmentContent();
    var ref1, ref2;
    const labels = React.useMemo(()=>{
        var ref, ref4;
        return {
            title: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getFormattedLabel('appointments.page.reschedule.reservation.title', {
                labelData: {
                    name: (ref1 = appointment === null || appointment === void 0 ? void 0 : (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }) : getFormattedLabel('appointments.page.reschedule.confirm.title', {
                labelData: {
                    name: (ref2 = appointment === null || appointment === void 0 ? void 0 : (ref4 = appointment.invitee) === null || ref4 === void 0 ? void 0 : ref4.firstName) !== null && ref2 !== void 0 ? ref2 : ''
                }
            }),
            subtitle: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.subtitle') : getLabel('appointments.page.reschedule.confirm.subtitle'),
            confirmation: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.confirmation') : getLabel('appointments.page.reschedule.confirm.confirmation'),
            additionalInformation: getLabel('appointments.page.reschedule.confirm.additionalInformation'),
            addToCalendar: getLabel('appointments.page.reschedule.confirm.addToCalendar'),
            where: getLabel('appointments.page.reschedule.confirm.where'),
            who: getLabel('appointments.page.reschedule.confirm.who'),
            cantMakeIt: getLabel('appointments.page.reschedule.confirm.cantMakeIt'),
            getDirections: getLabel('appointments.page.reschedule.confirm.getDirections'),
            returnLabel: getLabel('appointments.page.cancel.reschedule.closeButtonLabel.backHome'),
            confirmationEmailInstruction: getFormattedLabel('appointments.page.reschedule.confirm.confirmationEmailInstruction', {
                parseLink: true
            }),
            notification: (appointment === null || appointment === void 0 ? void 0 : appointment.preferredChannelOfCommunication) === AppointmentCommunicationChannel.EMAIL ? getLabel('appointments.page.cancel.confirm.notification.email') : getLabel('appointments.page.cancel.confirm.notification.sms'),
            child: getLabel('appointments.component.appointmentOverview.child')
        };
    }, [
        appointment,
        getLabel,
        getFormattedLabel
    ]);
    const directionsUrl = store ? getDirectionsUrl({
        streetName: store.streetName,
        town: store.town,
        opco
    }) : undefined;
    const appointmentConfirmationContent = React.useMemo(()=>{
        var ref8, ref6, ref7;
        const appointmentContent = appointmentDisplayType === 'group' ? (ref8 = appointmentTypes) === null || ref8 === void 0 ? void 0 : ref8.reduce((acc, appointmentGroup)=>{
            appointmentGroup.appointmentTypes.forEach((entry)=>{
                if (entry.appointmentConfirmationContent) {
                    acc[entry.typeId] = entry.appointmentConfirmationContent;
                }
            });
            return acc;
        }, {}) : (ref6 = appointmentTypes) === null || ref6 === void 0 ? void 0 : ref6.find((content)=>{
            var ref;
            return content.typeId === (appointment === null || appointment === void 0 ? void 0 : (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id);
        });
        return (ref7 = appointmentContent) === null || ref7 === void 0 ? void 0 : ref7.appointmentConfirmationContent;
    }, [
        appointmentTypes,
        appointment === null || appointment === void 0 ? void 0 : (ref5 = appointment.appointmentType) === null || ref5 === void 0 ? void 0 : ref5.id
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        getStoreOffer({
            variables: {
                globalStoreId: store.globalStoreId
            }
        });
    }, [
        getStoreOffer,
        appointment,
        store
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref9;
            var ref10, ref11;
            const dataLayerEvent = rescheduleAppointmentConfirmationScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: (ref10 = (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) !== null && ref10 !== void 0 ? ref10 : '',
                        ageGroup: (ref11 = (ref9 = appointment.appointmentType) === null || ref9 === void 0 ? void 0 : ref9.ageGroup) !== null && ref11 !== void 0 ? ref11 : 'ADULT'
                    }
                },
                store: store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    const appointmentType = React.useMemo(()=>{
        return !(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType) ? undefined : {
            id: appointment.appointmentType.id,
            ageGroup: appointment.appointmentType.ageGroup
        };
    }, [
        appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType
    ]);
    const { pushAddToCalendarDlEvent  } = useAddToCalendarDlEventDispatcher({
        appointmentCondition: 'new',
        type: appointmentType,
        store,
        isVirtualAppointment: isVirtualAppointmentType(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType),
        timeSlot: selectedTimeSlot
    });
    if (!appointment) {
        // TODO: add empty screen in scope of the ticket https://jira.grandvision.global/browse/GAAB-3886
        return null;
    }
    var _data, ref3;
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentConfirmation, {
        labels: labels,
        appointment: appointment,
        store: store,
        offers: (_data = storeOffer.data) !== null && _data !== void 0 ? _data : emptyArray,
        timeSlot: selectedTimeSlot,
        googleMapsApiKey: googleMapsApiKey,
        directionsUrl: directionsUrl,
        storesUrl: storesUrl,
        appointmentConfirmationContent: appointmentConfirmationContent,
        offerFallbackImageUrl: offerFallbackImageUrl,
        isVirtualAppointmentType: isVirtualAppointmentType(appointment.appointmentType),
        returnPath: (()=>{
            var ref;
            const rawReturnPath = (ref = fromArrayToString(returnPath)) !== null && ref !== void 0 ? ref : '/';
            return isSafePath(rawReturnPath) ? rawReturnPath : '/';
        })(),
        returnLabel: (ref3 = fromArrayToString(returnLabel)) !== null && ref3 !== void 0 ? ref3 : labels.returnLabel,
        onICSButtonClick: pushAddToCalendarDlEvent
    });
};

export { RescheduleAppointmentConfirmationContainer as default };
//# sourceMappingURL=RescheduleAppointmentConfirmationContainer.js.map
